module.exports = __webpack_public_path__ + "static/media/baptisthealth.225d98c8.png";